module.exports = __webpack_public_path__ + "static/media/banner2.8c887206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2.jpg
// module id = 667
// module chunks = 0